import axiosClient from './axiosClient';

const kycService = {
    adminUpdateKycStatus: async (kycId, payload) => {
        const response = await axiosClient.put(`/admin/kyc/${kycId}/status`, { status: payload.status, message: payload.message });
        return response.data;
    },
    adminUpdateAddressStatus: async (kycId, payload) => {
        const response = await axiosClient.put(`/admin/kyc/${kycId}/address`, { status: payload.status, message: payload.message });
        return response.data;
    },
    adminUpdateIdentityStatus: async (kycId, payload) => {
        const response = await axiosClient.put(`/admin/kyc/${kycId}/identity`, { status: payload.status, message: payload.message });
        return response.data;
    },
    adminUpdateGuarantorStatus: async (kycId, payload) => {
        const response = await axiosClient.put(`/admin/kyc/${kycId}/guarantor`, { status: payload.status, message: payload.message });
        return response.data;
    },
    adminUpdateNextOfKinStatus: async (kycId, payload) => {
        const response = await axiosClient.put(`/admin/kyc/${kycId}/nextofkin`, { status: payload.status, message: payload.message });
        return response.data;
    },
    adminGetUserKyc: async (userId) => {
        const response = await axiosClient.get(`/admin/kyc/user/${userId}`);
        return response.data;
    }
};

export default kycService;
